import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgRustwoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M11 16a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m8 14 12-8 12 8v20H8z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m25.525 11.33 8.6 5.97-.57.82-8.6-5.97z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M25.71 23.71A2.29 2.29 0 0 0 23.43 26 5 5 0 0 0 20 24.86 5 5 0 0 0 16.57 26a2.29 2.29 0 1 0-3.07 2.14l.59 2.7A1.38 1.38 0 0 0 15.43 32v.61a.4.4 0 0 0 .4.4h.34a.4.4 0 0 0 .4-.4V32h6.86v.6a.4.4 0 0 0 .4.4h.34a.4.4 0 0 0 .4-.4V32a1.38 1.38 0 0 0 1.34-1.15l.59-2.7a2.28 2.28 0 0 0-.79-4.43z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M17.18 24.44a7.15 7.15 0 0 1 5.64 0 3.27 3.27 0 0 1 2.33-1.67L24.67 18a1.12 1.12 0 0 0-1.12-1h-7.1a1.12 1.12 0 0 0-1.12 1l-.48 4.75a3.27 3.27 0 0 1 2.33 1.69"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M11.5 3v2h-1V3zM4.32 6.567l1.73 1-.5.866-1.73-1zM3.82 14.567l1.73-1 .5.866-1.73 1z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgRustwoning);

export default ForwardRef;
